<template lang="pug">
  div.wrap-module-add-slide
    div.add-slide-content.py12
      v-text-field(v-model="title" label="Title"
        placeholder="New Presentation" :color="pallete.$active_color")
      v-textarea(v-model="description" label="Description"
        placeholder="Awesome Presentation" :color="pallete.$active_color")
      div.wrap-slide-uploader
        span.fz14.mb8.block Your slide
        ItemSlideUploader(ref="slideUploader")
        //- div.dd-area.f.fh
          div
            div.f.fc.mb6
              v-icon(size="120px") mdi-file-upload-outline
            span.text-center.fz16.block.bold Upload slide data
            span.text-center.fz14.block (pdf, jpg, png)
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-module-add-slide {
  padding-top: $header_height;
  .add-slide-content {
    margin: 0 auto;
    width: $base_width_percent;
    max-width: $base_max_width_px;
    .wrap-slide-uploader {
      .dd-area {
        width: 100%;
        height: 320px;
        border-radius: 9px;
        border: dotted 1.4px $primary_text_color;
      }
    }
  }
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import ItemSlideUploader from '@/components/item/ItemSlideUploader'

export default {
  components: {
    ItemSlideUploader
  },
  props: {
    // data: {
    //   type: Object,
    //   required: true
    // }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  data () {
    return {
      title: '',
      description: ''
    }
  },
  methods: {
    onLoggedIn () {
      
    },
    onFailedAuthentication () {
      this.$router.push('/sign-in')
    }
  }
}
</script>
